import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useToasts } from "@air/provider-toast";
import { useMutation } from "@tanstack/react-query";
import { ToastLink } from "~/components/UI/ToastLink";
import { useGoToBoardPage } from "~/hooks/useGoToBoardPage";
import { useMoveBoards } from "~/swr-hooks/boards/useMoveBoards";
import { useMoveAssetsToBoard } from "~/swr-hooks/clips/useMoveAssetsToBoard";
import { reportErrorToBugsnag } from "~/utils/ErrorUtils";
import { insertIf } from "~/utils/insertIf";
import { getBoardIdFromPath } from "~/utils/PathUtils";
export const useMoveItems = (param)=>{
    let { boards = [], clips = [], trackLocation } = param;
    const { showToast } = useToasts();
    const { goToBoardPage } = useGoToBoardPage();
    const { moveBoards: { mutate: moveBoards } } = useMoveBoards();
    const { moveAssetsToBoard: { mutate: moveAssetsToBoard } } = useMoveAssetsToBoard();
    const moveItems = useMutation({
        mutationFn: (param)=>{
            let { selectedBoard, selectedLibrary } = param;
            const currentBoardId = getBoardIdFromPath(window.location.pathname);
            return Promise.all([
                ...insertIf(boards.length > 0, ()=>[
                        moveBoards({
                            newParentId: (selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.id) !== "root" ? (selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.id) || null : null,
                            boards,
                            library: selectedLibrary
                        })
                    ]),
                ...insertIf(clips.length > 0 && !!currentBoardId && !!selectedBoard, ()=>[
                        moveAssetsToBoard({
                            clipsInfo: clips,
                            board: selectedBoard,
                            trackLocation,
                            parentBoardId: currentBoardId
                        })
                    ])
            ]);
        },
        onSuccess: (_data, param)=>{
            let { onMove, selectedBoard, selectedLibrary } = param;
            const isRootBoard = (selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.id) === "root";
            onMove === null || onMove === void 0 ? void 0 : onMove();
            showToast(/*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    "Moved to ",
                    selectedBoard && /*#__PURE__*/ _jsx(ToastLink, {
                        onClick: ()=>{
                            /**
                 * When we move the board to the top-level, we need to redirect the
                 * user to the board that was moved to prevent a 404 error.
                 */ goToBoardPage({
                                board: isRootBoard ? boards[0] : selectedBoard,
                                trackLocation: "moved-board-toast"
                            });
                        },
                        children: isRootBoard ? "top-level" : selectedBoard.title
                    }),
                    selectedLibrary && selectedLibrary.title
                ]
            }));
        },
        onError: (error, param)=>{
            let { selectedBoard, selectedLibrary } = param;
            return reportErrorToBugsnag({
                error,
                context: "Failed to move a private board",
                metadata: {
                    boards,
                    clips,
                    selectedBoard,
                    selectedLibrary
                }
            });
        }
    });
    return {
        moveItems
    };
};
